<template>
  <div class="space-card-wrap relative cursor-pointer"
       :class="horizontal ? 'flex flex-row items-stretch' : ''"
       @click="handleSpaceClick(spaceCardObj.space_id)">
    <FavoriteButton class="absolute top-2 left-2 z-10"
                    :space-id="spaceCardObj.space_id" />
    <!-- AV P2 刀2:檔期三態徽章(可立即預約/可能可用/可詢問);未同步一律降級,不誆稱可用。 -->
    <div v-if="availabilityBadge"
         class="absolute top-2 right-2 z-10 px-2 py-0.5 rounded-md text-[12px] font-medium"
         :class="availabilityBadge.class">
      {{ $t(availabilityBadge.key) }}
    </div>
    <NuxtImg format="webp"
             quality="80"
             loading="lazy"
             :sizes="sizes"
             :src="picUrl+spaceCardObj.photo_url"
             class="aspect-[1024/683]"
             :class="horizontal ? 'rounded-l-xl w-[45%] shrink-0 object-cover' : (fillWidth ? 'rounded-t-xl w-full object-cover' : 'rounded-t-xl')"
             :alt="spaceCardObj.photo_description?spaceCardObj.photo_description:spaceCardObj.space_name"/>
    <div :class="horizontal ? 'flex-1 flex flex-col justify-center px-[24px]' : 'px-[24px] pt-[10px]'">
<!--      <h3 class="text-[15px] text-osn-grey-01 truncate">{{ spaceCardObj.brand_name }}</h3>-->
      <div class="h-[48px] text-[16px] font-bold text-osn-dark-grey-00 line-clamp-2">{{ spaceCardObj.space_name }}</div>
      <div class="tag-wrap">

        <ul>
          <li class="usage"
              v-for="item in spaceCardObj.categories[usageCategoryId]">{{ item.name }}
          </li>
          <!--          <li class="type"
                        v-for="item in spaceCardObj.categories[typeCategoryId]">{{ item.name }}
                    </li>
                    <li class="tag"
                        v-for="item in spaceCardObj.categories[tagCategoryId]">{{ item.name }}
                    </li>-->
        </ul>
      </div>

      <div class="pc:mt-3 min-h-[20px] inline-flex items-center text-[14px]">
        <svg-icon v-if="spaceCardObj.traffics.length>0"
                  class="mr-[5px]"
                  name="mrt"
                  size="20"></svg-icon>
        <span v-if="spaceCardObj.traffics.length>0">{{
            `${spaceCardObj.traffics[0]?.mrt_station} ${spaceCardObj.traffics[0]?.mrt_exit} 號出口`
          }}</span>
        <span v-if="spaceCardObj.traffics.length>0"
              class="ml-[3px] text-osn-grey-01">{{
            $t('space.walking_time', {t: spaceCardObj.traffics[0]?.walking_time})
          }}</span>
      </div>
      <div class="mt-[8px] px-[4px] pb-[18px] flex justify-between items-center">
        <div class="font-semibold text-[16px]">
          <span class="mr-[5px]">{{ parseFormatCheapestRentPrice(spaceCardObj.rent.rent_groups) }}</span>
          <span class="font-normal text-osn-grey-01 text-[14px]">{{
              `/${parseFormatCheapestRentType(spaceCardObj.rent.rent_groups)}`
            }}</span>
        </div>
        <div class="text-osn-grey-01 text-[14px] inline-flex items-center">
          <svg-icon class="mr-[4px]"
                    name="people"
                    size="16"></svg-icon>
          {{ spaceCardObj.number_of_people_max + '人' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import {parseTrafficsMRT} from '@/utils/parseTool.js'
import {parseFormatCheapestRentPrice, parseFormatCheapestRentType} from "~/utils/newPriceTool.ts";
import FavoriteButton from "@/components/Favorite/FavoriteButton.vue";


const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL
const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID
const tagCategoryId = import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID
const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID
const router = useRouter()

const props = defineProps({
  spaceCardObj: {
    type: Object,
    default: {}
  },
  // 橫向版型（圖左、資料右）；圖片比例與顯示資料不變，只改排列。
  horizontal: {
    type: Boolean,
    default: false
  },
  // 讓圖片填滿卡片寬度（grid 版型用；swiper 維持原本以 intrinsic 寬度呈現）。
  fillWidth: {
    type: Boolean,
    default: false
  },
  // NuxtImg 的 sizes（依版型給對應來源解析度，避免放大模糊）。
  sizes: {
    type: String,
    default: '100vw md:259px'
  }
})

// AV P2 刀2:檔期三態視覺(綠=可立即預約 / 琥珀=可能可用 / 灰=可詢問),沿用詳情頁
// SpaceOverview 的配色與 i18n key。無 availability(批次失敗或後端未回)則不顯示徽章。
const availabilityBadge = computed(() => {
  const meta = {
    reservable: {key: 'availability.reservable', class: 'bg-osn-green-1 text-osn-green-4'},
    maybe: {key: 'availability.maybe', class: 'bg-osn-yellow-06 text-osn-yellow-03'},
    inquiry: {key: 'availability.inquiry', class: 'bg-osn-grey-04 text-osn-grey-01'}
  }
  return meta[props.spaceCardObj?.availability] || null
})

function handleTrafficInfo(info) {
  return parseTrafficsMRT(info)

}

function handleSpaceClick(spaceId) {
  const route = router.resolve({path: `/space/${spaceId}`})
  window.open(route.href, '_blank')
}

</script>
<style scoped
       lang="scss">
.space-card-wrap {
  @apply rounded-xl border;

  .tag-wrap {
    @apply mt-1 pc:h-[100px] mobile:h-[85px] text-[13px];
    ul {
      @apply flex flex-wrap;
      li {
        @apply w-auto h-[23px] mr-[2px] mb-[2px] px-[6px] py-[2px] bg-osn-yellow-00 rounded-md;
      }

      li.type {
        @apply bg-osn-yellow-04 text-[11px] py-[4px];
      }

      li.tag {
        @apply bg-osn-yellow-05 text-[11px] py-[4px];
      }

    }
  }
}

</style>
